// Detect mobile or desktop device
function detectMobile() {
	if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
		document.body.classList.add("mobile")
	} else {
		document.body.classList.add("desktop")
	}
}

detectMobile()

// Fix jumping layout on body scroll off
function getScrollbarWidth() {
	const outer = document.createElement("body")
	outer.style.visibility = "hidden"
	outer.style.overflow = "scroll"
	outer.style.msOverflowStyle = "scrollbar"
	document.body.appendChild(outer)

	const inner = document.createElement("body")
	outer.appendChild(inner)

	const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth)
	outer.parentNode.removeChild(outer)

	return scrollbarWidth
}

const scrollbarWidth = getScrollbarWidth()

if(scrollbarWidth === 15) {
	document.body.classList.add("scroll-offset")
}
